var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trims-accessories-container" }, [
    _c("div", { staticClass: "trims-accessories-header-wrapper" }, [
      _c("h2", [
        _vm._v(_vm._s(_vm.$resourceString["trimsaccessories.header"]))
      ]),
      _vm._v(" "),
      _c("h5", { staticClass: "localRepDisclaimer" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$resourceString["trimsaccessories.contactManagerText"]) +
            "\n      "
        ),
        _c(
          "a",
          {
            staticClass: "hyperlinkStyle",
            on: {
              click: function($event) {
                return _vm.contactManager()
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$resourceString[
                    "trimsaccessories.contactManagerAnchorText"
                  ]
                ) +
                "\n      "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { attrs: { id: "vue-wf-product-category" } }, [
        _c("div", { staticClass: "wf-page-controls mt-4 mt-lg-0" }, [
          _c("div", { staticClass: "wf-page-controls-items" }, [
            _c(
              "div",
              {
                staticClass:
                  "wf-page-control-item wf-page-control-item-current-refinements"
              },
              [_c("current-filters")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "wf-page-control-item wf-page-control-item-product-display-controls"
              },
              [_c("pc-trims-accessories-controls")],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wf-product-category" }, [
          _c("div", { staticClass: "wf-product-category-sidebar-mobile" }, [
            _c(
              "div",
              {
                staticClass: "wf-side-collapse",
                attrs: { id: "filters-side-collapse" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "wf-side-collapse-header justify-content-end"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "wf-side-collapse-button wf-side-collapse-button-close btn",
                        attrs: { type: "button" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$resourceString["product.search.close.button"]
                            ) +
                            "\n                "
                        ),
                        _c("span", {
                          staticClass: "png-icon png-icon-icons-glyph--g-close",
                          attrs: { "aria-label": "close button" }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "wf-side-collapse-body" }, [
                  _c(
                    "div",
                    { staticClass: "wf-side-collapse-section" },
                    [_c("current-filters")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wf-side-collapse-section" },
                    [_c("side-filters")],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "wf-product-category-sidebar-desktop filtersMargin"
            },
            [_c("side-filters")],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wf-product-category-results" }, [
            _c(
              "section",
              { staticClass: "wf-product-category-results-section" },
              [
                _c("div", { staticClass: "container-fluid" }, [
                  _c("h2", { staticClass: "secondary-heading" }, [
                    _vm._v("\n                Styles\n              ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wf-product-category-results" },
                    [
                      _c(
                        "div",
                        { staticClass: "wf-product-category-results" },
                        [
                          _c(
                            "div",
                            {
                              key: _vm.tileSize,
                              staticClass: "wf-search-results",
                              class: [
                                "wf-search-results-tile-size-" + _vm.tileSize
                              ]
                            },
                            [
                              _vm._l(_vm.trimsAndAccessories, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "wf-search-result description"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "wf-swiper",
                                            rawName: "v-wf-swiper",
                                            value: {
                                              parameters: {
                                                initialSlide: 0,
                                                allowTouchMove: false
                                              },
                                              slideChangeEvent:
                                                _vm.onSlideChange
                                            },
                                            expression:
                                              "{\n                        parameters: {\n                          initialSlide: 0,\n                          allowTouchMove: false\n                        },\n                        slideChangeEvent: onSlideChange\n                      }"
                                          }
                                        ],
                                        staticClass: "swiper-container",
                                        attrs: { id: "swiper-" + index }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "main-image" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "wf-product-quick-view-swatch-slide"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "px-0 w-100 cart-item-model-no"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "swatch-slide-image"
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass: "image",
                                                          attrs: {
                                                            alt:
                                                              item.trimColors[0]
                                                                .imageAltText ||
                                                              "",
                                                            src:
                                                              item.trimColors[0]
                                                                .imagePath
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "swiper-wrapper" },
                                          _vm._l(item.trimColors, function(
                                            trimColor,
                                            colorIndex
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: colorIndex,
                                                staticClass: "swiper-slide"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "active-color-header position-absolute d-flex flex-column accessoryDescription"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        style: {
                                                          fontWeight: "bold"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                " +
                                                            _vm._s(
                                                              item.sellingStyleName +
                                                                " " +
                                                                item.sellingStyleNumber
                                                            ) +
                                                            "\n                              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "trimColors"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                " +
                                                            _vm._s(
                                                              item.trimColors
                                                                .length +
                                                                " " +
                                                                (item.trimColors
                                                                  .length !== 1
                                                                  ? "colors"
                                                                  : "color")
                                                            ) +
                                                            "\n                                -\n                                " +
                                                            _vm._s(
                                                              "" +
                                                                trimColor.colorName.toLowerCase()
                                                            ) +
                                                            "\n                              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "construction"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                " +
                                                            _vm._s(
                                                              item.construction
                                                            ) +
                                                            "\n                              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    item.tearSheetLink
                                                      ? _c("div", [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "learnMore",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.learnMore(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                  " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .$resourceString[
                                                                      "trimsaccessories.learnMore"
                                                                    ]
                                                                  ) +
                                                                  "\n                                "
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.specSheetLink
                                                      ? _c("div", [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "learnMore",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.specSheet(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                  " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .$resourceString[
                                                                      "trimsaccessories.specSheet"
                                                                    ]
                                                                  ) +
                                                                  "\n                                "
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "wf-swiper-thumbnails wf-swiper-thumbnails-with-nav-buttons\n                      d-none on-hover-thumbnails ml-3 mr-3 wf-product-thumbnails-size-small thumbSwiper"
                                          },
                                          [
                                            item.trimColors.length > 1
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "wf-swiper-nav-button wf-swiper-nav-button-prev btn btn-full",
                                                    attrs: { type: "button" }
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "png-icon png-icon-icons-glyph--ko-chevron-left png-size arrow-left mt-1",
                                                      attrs: {
                                                        "aria-label":
                                                          "Previous color"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "wf-swiper-thumbnails-container"
                                              },
                                              _vm._l(item.trimColors, function(
                                                trimColor
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "wf-swiper-thumbnail"
                                                  },
                                                  _vm._l(
                                                    trimColor.imagesInfo,
                                                    function(imageInfo) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key:
                                                            trimColor.colorNumber,
                                                          staticClass:
                                                            "imageInfo"
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "cart-item-model-no"
                                                            },
                                                            [
                                                              _c("div", {
                                                                staticClass:
                                                                  "red-underline"
                                                              }),
                                                              _vm._v(" "),
                                                              _c("img", {
                                                                staticClass:
                                                                  "image-thumbnail",
                                                                attrs: {
                                                                  alt:
                                                                    imageInfo.imageAltText ||
                                                                    "",
                                                                  src:
                                                                    imageInfo.url
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              }),
                                              0
                                            ),
                                            _vm._v(" "),
                                            item.trimColors.length > 1
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "wf-swiper-nav-button wf-swiper-nav-button-next btn btn-full",
                                                    attrs: { type: "button" }
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "png-icon png-icon-icons-glyph--ko-chevron-right arrow-right png-size mt-1",
                                                      attrs: {
                                                        "aria-label":
                                                          "Next color"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.trimsAndAccessories.length === 0 &&
                              !_vm.isFetching
                                ? _c("p", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "common.noResults"
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showLoadMore
                        ? _c("pc-load-more", {
                            attrs: { "load-more": _vm.onLoadMore }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }